<!-- start::FILTERS & GROUP ACTIONS -->
<div class="card">
  <div class="card-body">
    <div class="form mb-3">
      <div class="form-filtration">
        <div class="row align-items-center">
          <div class="col-md-2 kt-margin-bottom-10-mobile"></div>
          <div class="col-md-8 kt-margin-bottom-10-mobile"></div>
          <div *ngIf="!isViewMode" class="col-md-2 text-right kt-margin-bottom-10-mobile">
            <button
              type="button"
              (click)="addDrugs()"
              mat-raised-button
              color="primary"
              matTooltip="Add drugs"
              [disabled]="isSwitchedToEditMode"
            >
              <span class="svg-icon-md" translate="PHARMACY_GROUP_DRUG.ADD_PHARMACY_GROUP_DRUGS">
                <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
                Add Drugs
              </span>
            </button>
          </div>
        </div>
      </div>
      <!-- end::FILTERS -->
    </div>
    <!-- end::FILTERS & GROUP ACTIONS -->

    <!-- MATERIAL TABLE | Binded to datasources -->
    <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->

    <div class="mat-table-wrapper mat-table-wrapper-sub">
      <form [formGroup]="formGroup">
        <mat-table
          class="lmat-elevation-z8"
          [dataSource]="dataSource"
          matSort
          matSortActive="id"
          matSortDirection="desc"
          matSortDisableClear
        >
          <!-- Checkbox Column -->
          <!-- Table with selection -->
          <!-- https://run.stackblitz.com/api/angular/v1?file=app%2Ftable-selection-example.ts -->
          <!-- Checkbox Column -->

          <ng-container matColumnDef="drug">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="mat-column"
              translate="PHARMACY_GROUP_DRUG.TABLE.NAME"
              >Name
            </mat-header-cell>
            <mat-cell *matCellDef="let drug" class="mat-column">
              <span>{{ drug.drug_name }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ndc">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="mat-column"
              translate="PHARMACY_GROUP_DRUG.TABLE.NDC"
              >NDC
            </mat-header-cell>
            <mat-cell *matCellDef="let drug" class="mat-column">
              <span>{{ drug.drug_ndc }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="price">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="mat-column"
              translate="PHARMACY_GROUP_DRUG.TABLE.PRICE"
              >PRICE
            </mat-header-cell>
            <mat-cell *matCellDef="let drug" class="mat-column">
              <mat-form-field *ngIf="drug._isEditMode" class="mat-form-field-fluid">
                <mat-label translate="PHARMACY_GROUP_DRUG.FORM.PRICE">Price</mat-label>
                <input matInput type="number" formControlName="editPrice" />
              </mat-form-field>
              <span *ngIf="!drug._isEditMode">{{ drug.price }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="description">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="mat-column"
              translate="PHARMACY_GROUP_DRUG.TABLE.DESCRIPTION"
              >Description
            </mat-header-cell>
            <mat-cell *matCellDef="let drug" class="mat-column">
              <mat-label translate="PHARMACY_GROUP_DRUG.FORM.DESCRIPTION"
                >Drug Description</mat-label
              >
              <mat-checkbox formControlName="editIsActive"></mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="is_active">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              translate="PHARMACY_GROUP_DRUG.TABLE.STATUS"
              >Status
            </mat-header-cell>
            <mat-cell *matCellDef="let drug">
              <span
                class="label label-lg label-light-{{
                  getItemCssClassByStatus(drug.is_active)
                }} label-inline"
                >{{ getItemStatusString(drug.is_active) }}</span
              >
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef class="mat-column-actions" translate="TABLE.ACTIONS">
              Actions
            </mat-header-cell>
            <mat-cell *matCellDef="let drug" class="mat-column-actions">
              <button
                *ngIf="!drug._isEditMode"
                [disabled]="isSwitchedToEditMode"
                type="button"
                mat-icon-button
                color="primary"
                (click)="editDrugButtonOnClick(drug)"
                class="margin-2"
                matTooltip="Edit drug"
              >
                <span class="svg-icon svg-icon-md svg-icon-primary">
                  <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
                </span>
              </button>
              <button
                *ngIf="!drug._isEditMode"
                [disabled]="isSwitchedToEditMode"
                mat-icon-button
                color="warn"
                type="button"
                (click)="deleteDrug(drug)"
                class="margin-2"
                matTooltip="Delete drug"
              >
                <span class="svg-icon svg-icon-md svg-icon-danger">
                  <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>
                </span>
              </button>
              <button
                *ngIf="drug._isEditMode && !loadingAfterSubmit"
                mat-icon-button
                color="{{ checkEditForm() ? 'primary' : 'accent' }}"
                type="button"
                (click)="editDrug(drug)"
                matTooltip="Save changes"
              >
                <mat-icon>done</mat-icon>
              </button>
              <mat-spinner
                *ngIf="drug._isEditMode && loadingAfterSubmit"
                [diameter]="20"
              ></mat-spinner>
              &nbsp;
              <button
                *ngIf="drug._isEditMode"
                type="button"
                mat-icon-button
                color="warn"
                (click)="cancelEditButtonOnClick(drug)"
                matTooltip="Cancel changes"
              >
                <mat-icon>clear</mat-icon>
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ 'mat-row-editing': row._isEditMode }"
          ></mat-row>
        </mat-table>
      </form>

      <div
        class="mat-table-message"
        *ngIf="!dataSource.hasItems"
        translate="GLOBAL.NO_RECORDS_FOUND"
      >
        No Records Found
      </div>
      <div
        class="mat-table-message"
        *ngIf="dataSource.isPreloadTextViewed$ | async"
        translate="GLOBAL.PLEASE_WAIT"
      >
        Please Wait...
      </div>
    </div>

    <!-- start: BOTTOM -->
    <div class="mat-table-bottom bg-white">
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </div>
</div>
<!-- end: BOTTOM -->
